import { FloatingFormItem, InputText } from '@/components/_common';
import { Col, Divider, Input, Row, Typography } from 'antd';
import React from 'react';

const RegisterDataWorkOrder: React.FC = () => {
  return (
    <>
      <Typography.Title level={4} style={{ margin: 0 }}>
        Pesquisar por dados da O.S
      </Typography.Title>

      <Divider style={{ margin: 0, marginBottom: 24 }} />

      <Row gutter={[12, 12]}>
        <Col span={24} md={8}>
          <FloatingFormItem label="Código OS" name="workOrderNumber">
            <InputText onlyNumber />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8}>
          <FloatingFormItem label="Sinistro" name="accidentNumber">
            <Input />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8}>
          <FloatingFormItem label="Placa veículo" name="licensePlate">
            <Input />
          </FloatingFormItem>
        </Col>
      </Row>
    </>
  );
};

export default RegisterDataWorkOrder;
